export const fileUrlToFileName = (fileUrl: string): string => {
  const urlParts = fileUrl.split('/');
  return urlParts[urlParts.length - 1];
};
